// SignInFaq.tsx
export const SignInFaq = [
  {
    question: "Do you keep my original face?",
    answer:
      "No, we never permanently store your original face. Your uploaded images are kept for only 30 minutes to allow you to compare before and after results, then are automatically and permanently deleted from our servers. We've designed our entire system around the principle that your face data belongs to you alone."
  },
  {
    question: "Do I need a credit card to sign up?",
    answer:
      "No, signing up for a Neoface account is completely free. You can create an account and use the platform without providing any payment information. Premium features are available with paid subscriptions, but the basic account is always free."
  },
  {
    question: "How is my data kept private?",
    answer:
      "At Neoface, we take your privacy extremely seriously. We use bank-grade encryption for all uploads, and your original face images are kept only temporarily (for 30 minutes) to allow you to compare results, then are permanently deleted from our servers. We never store your biometric data, sell your information to third parties, or keep facial recognition templates. All processing happens in secure, isolated environments with strict access controls."
  },
  {
    question: "Can my anonymized face be reverse-engineered?",
    answer:
      "No, the anonymization process we use is designed to be non-reversible. The output contains none of your original facial data, making it impossible to reconstruct your real face from the anonymized version. Our technology creates a completely new face while preserving natural expressions and movements, ensuring your identity remains protected."
  },
  {
    question: "Can I use Neoface for both SFW and NSFW content?",
    answer:
      "Yes, Neoface is designed to work with all types of content. Our privacy-first approach means your identity is protected regardless of the content type. Many content creators use Neoface to maintain anonymity while maximizing engagement on platforms with different content policies."
  },
  {
    question: "How can Neoface help me earn more as a content creator?",
    answer:
      "Content with faces receives up to 3x more engagement on social platforms. By using Neoface, you can show a consistent face in your content while protecting your real identity. This helps increase your views, likes, and subscriber count while maintaining your privacy and safety in the real world."
  },
  {
    question: "What happens to metadata in my photos and videos?",
    answer:
      "Neoface automatically strips all metadata from your uploads, including location data, device information, and other identifying details. This provides an additional layer of privacy protection beyond just changing your face."
  },
  {
    question: "Is Neoface GDPR compliant?",
    answer:
      "Yes, Neoface is fully GDPR compliant. We process data only with your explicit consent, maintain minimal data retention periods, implement all required security measures, and provide complete transparency about our data practices. You can request data deletion at any time through your account settings."
  }
];